import _styled from '@emotion/styled/base';
import { spacing } from '@hubble/tokens/web';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import { mediaQuery } from '../primitives/media-queries.js';

const RootStyles = _styled(ScrollAreaPrimitive.Root, {
  target: "e1ngj8gy3"
})("overflow:hidden;height:", ({
  height
}) => height, ";width:", ({
  width
}) => width, ";--scrollbar-size:12px;");
const ViewportStyles = _styled(ScrollAreaPrimitive.Viewport, {
  target: "e1ngj8gy2"
})({
  name: "1kzq5ms",
  styles: "height:100%;width:100%"
} );
const ScrollAreaScrollbarStyles = _styled(ScrollAreaPrimitive.ScrollAreaScrollbar, {
  target: "e1ngj8gy1"
})("display:flex;touch-action:none;user-select:none;padding:", spacing[8], " ", spacing[4], ";box-sizing:border-box;&[data-orientation='vertical']{height:100%;width:var(--scrollbar-size);}");
const ScrollAreaThumbStyles = _styled(ScrollAreaPrimitive.ScrollAreaThumb, {
  target: "e1ngj8gy0"
})("flex:1;background:", ({
  theme
}) => theme.colorScheme.border.primary, ";border-radius:var(--scrollbar-size);position:relative;@media ", mediaQuery.tabletMdDown, "{&::before{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);width:100%;height:100%;min-width:44px;min-height:44px;}}");

export { RootStyles, ScrollAreaScrollbarStyles, ScrollAreaThumbStyles, ViewportStyles };
